import React, { Component } from "react";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import LocationSidebar from "../components/LocationSidebar";

const bg = require("../../../../images/servicehero.png");

class HouseCleaningCoffsHarbour extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="House Cleaning Coffs Harbour | Professional Home Cleaners"
          description="House cleaning Coffs Harbour services. Weekly and deep cleaning by experienced professionals."
          keywords="house cleaning coffs harbour, cleaning services coffs harbour, residential cleaning coffs harbour, home cleaning coffs harbour, domestic cleaning coffs harbour, weekly house cleaning coffs harbour, deep cleaning coffs harbour, move in cleaning coffs harbour, move out cleaning coffs harbour, apartment cleaning coffs harbour, unit cleaning coffs harbour, professional house cleaners coffs harbour, affordable house cleaning coffs harbour, reliable cleaners coffs harbour, same day house cleaning coffs harbour, eco friendly cleaning coffs harbour, sanitisation cleaning coffs harbour, kitchen cleaning coffs harbour, bathroom cleaning coffs harbour, rental property cleaning coffs harbour, relocation cleaning coffs harbour, property management cleaning coffs harbour, holiday home cleaning coffs harbour, trusted cleaning company coffs harbour, local cleaners coffs harbour, house cleaning near me coffs harbour, one off cleaning coffs harbour, floor cleaning coffs harbour, window cleaning coffs harbour, complete house cleaning coffs harbour"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  House Cleaning Services Coffs Harbour
                </h1>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <LocationSidebar activePage="/house-cleaning-coffs-harbour/" />
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            House Cleaning Services Coffs Harbour
                          </h4>
                          <p>
                            Maintaining a clean home contributes to health and
                            comfort. Our house cleaning Coffs Harbour service
                            provides reliable and detailed residential cleaning.
                          </p>

                          <h4 className="dlab-title m-t30">Regular Cleaning</h4>
                          <ul className="list-check primary">
                            <li>Vacuuming</li>
                            <li>Mopping</li>
                            <li>Bathroom cleaning</li>
                            <li>Kitchen cleaning</li>
                          </ul>

                          <h4 className="dlab-title m-t30">Deep Cleaning</h4>
                          <ul className="list-check primary">
                            <li>Appliance cleaning</li>
                            <li>Tile scrubbing</li>
                            <li>Window cleaning</li>
                          </ul>

                          <h4 className="dlab-title m-t30">
                            Why Choose Kangaroo Shine
                          </h4>
                          <ul className="list-check primary">
                            <li>Professional cleaners</li>
                            <li>Affordable pricing</li>
                            <li>Consistent quality</li>
                          </ul>

                          <p className="m-t30">
                            Book House Cleaning Coffs Harbour today.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default HouseCleaningCoffsHarbour;
